define(["exports", "styled-components"], function (_exports, _styledComponents) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.StyledPanel = void 0;
  _styledComponents = _interopRequireDefault(_styledComponents);

  var StyledPanel = _styledComponents.default.div.withConfig({
    displayName: "StyledPanel",
    componentId: "sc-z4dlj1-0"
  })(["> div:focus{outline:none;}"]);

  _exports.StyledPanel = StyledPanel;
});